module.exports = __webpack_public_path__ + "img/kleisma2m.7b5989db.webp";